export var EXTERNAL_LINK_TYPE = 'wix-draft-plugin-external-link';
export var LINK_TYPE = 'LINK';
//# sourceMappingURL=types.js.map